'use client';

import React from 'react';
import Box from '@mui/material/Box';
import theme from 'link/src/theme';

export const Wrap = ({ children }: {children: React.JSX.Element}) => {
    return (
        <Box sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '31px',
            mt: '90px',
            textAlign: 'center',
            background: 'white',
            borderRadius: theme.shape.borderRadius,
            p: '45px 21px',
        }}
        >
            {children}
        </Box>
    );
};

